export default {

  //
  //  functions for validating data
  //  https://murani.nl/blog/2015-09-28/nederlandse-reguliere-expressies/
  //

  email : (email) => {
    let regex = new RegExp(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i);
    return regex.test(email);
  },

  phonenumber_nl : (phone) => {
    phone = phone.replace(/ |-/g, '')
    let vast_nummer = new RegExp(/^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);
    let mobiel_nummer = new RegExp(/^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i);
    return (vast_nummer.test(phone) || mobiel_nummer.test(phone));
  },

  url : (url) => {
    let regex = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/);
    return regex.test(url);
  },

  zipcode_nl : (zipcode) => {
    let regex = new RegExp(/^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i);

    return regex.test(zipcode);
  },

  iban : (iban) => {
    let regex = new RegExp(/^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$/i);
    return regex.test(iban);
  },

}
